import React, { useEffect } from 'react'
import {
  Col, Row, FormGroup, Label,
  Modal, ModalBody, ModalFooter, ModalHeader,
  Card, CardHeader, CardBody, CardFooter,
  Button, UncontrolledTooltip, Table
} from 'reactstrap'
import ReactHtmlParser from 'react-html-parser'
import ReactSelect from 'react-select'
import { toast } from 'react-toastify'
import _ from 'lodash'

import PageTitle from 'components/PageTitle'
import ARKTable from 'components/Table'
import LoadingModal from 'components/Indicator/LoadingOverlay'
import PolicyForm from './components/privacyPolicyForm'
import PrivacyPolicyHOC from './actions'

import Lang from 'Lang/General'

const PrivacyPolicy = props => {

  useEffect( () => {
    props.getAllPrivacyPolicies({
      page: 1,
      is_paginated: true
    })
    props.getCenters({ is_paginated: false })
  }, [] )

  const handleSecurityModulesUpdate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'GDPR Center' })
      return tmpModules.is_update
    }
  }

  const renderEditModal = () => {
    return (
      <Modal isOpen={ props.showEditPrivacyPolicy } size="lg">
        <ModalHeader toggle={ () => props.onChangePrivacyPolicyHOC( 'showEditPrivacyPolicy', false ) }>
          { Lang[ 'EDIT_PRIVACY_POLICY' ][ props.data.languageReducer.lang ] }
        </ModalHeader>
        <ModalBody>
          {
            !_.isEmpty( props.selectedPrivacyPolicy ) && (
              <PolicyForm 
                selectedPrivacyPolicy={ props.selectedPrivacyPolicy }
                onChangePrivacyPolicyHOC={ props.onChangePrivacyPolicyHOC }
                lang={ props.data.languageReducer.lang } />
            )
          }
          { props.onLoadPrivacyPolicy && <LoadingModal /> }
        </ModalBody>
        <ModalFooter>
          <Button
            color='primary'
            onClick={ () => {
              if ( _.isEmpty( props.selectedPrivacyPolicy.content ) ) {
                toast.error( Lang[ 'CONTENT_VALIDATION_MESSAGE' ][ props.data.languageReducer.lang ] )
              } else {
                props.updatePrivacyPolicy( props.selectedPrivacyPolicy.center_id, props.selectedPrivacyPolicy ) 
              }
            }}>
            { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  const renderViewModal = () => {
    return (
      <Modal isOpen={ props.showViewPrivacyPolicy } size="lg">
        <ModalHeader toggle={ () => props.onChangePrivacyPolicyHOC( 'showViewPrivacyPolicy', false ) }>
          { Lang[ 'VIEW_PRIVACY_POLICY' ][ props.data.languageReducer.lang ] }
        </ModalHeader>
        <ModalBody>
          {
            !_.isEmpty( props.selectedPrivacyPolicy ) && (
              <Table className="mb-0" bordered>
                <tbody>
                  <tr>
                    <th scope="row">{ Lang[ 'CENTER' ][ props.data.languageReducer.lang ] }</th>
                    <td>{ props.selectedPrivacyPolicy.center_name }</td>
                  </tr>
                  <tr>
                    <th scope="row">{ Lang[ 'CONTENT' ][ props.data.languageReducer.lang ] }</th>
                    <td>{ ReactHtmlParser( props.selectedPrivacyPolicy.content[ props.data.languageReducer.lang ] ) }</td>
                  </tr>
                </tbody>
              </Table>
            )
          }
          { props.onLoadPrivacyPolicy && <LoadingModal /> }
        </ModalBody>
        <ModalFooter>
          <Button
            color='primary'
            onClick={ () => props.onChangePrivacyPolicyHOC( 'showViewPrivacyPolicy', false ) }>
            { Lang[ 'CLOSE' ][ props.data.languageReducer.lang ] }
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
  
  return (
    <>
      <div>
        <PageTitle
          heading={ Lang[ 'PRIVACY_POLICY' ][ props.data.languageReducer.lang ] }
          icon="pe-7s-menu icon-gradient bg-happy-fisher" />
        <Card className="mb-3">
          <CardHeader>{ Lang[ 'SEARCH' ][ props.data.languageReducer.lang ] }</CardHeader>
          <CardBody>
            <Row>
              <Col md={ 12 }>
                <FormGroup>
                  <Label>{ Lang[ 'CENTER' ][ props.data.languageReducer.lang ] }</Label>
                  <ReactSelect
                    options={ props.centers }
                    className="basic-multi-select"
                    placeholder={ Lang[ 'SELECT_PLACEHOLDER' ][ props.data.languageReducer.lang ] }
                    onChange={ value => props.onChangePrivacyPolicyHOC( 'searchCenter', value ) }
                    value={ !_.isEmpty( props.searchCenter ) && props.searchCenter } />
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button
              color="primary"
              className="ml-auto"
              onClick={ () => {
                props.getAllPrivacyPolicies({
                  page: 1,
                  is_paginated: true,
                  filter: {
                    center_id: props.searchCenter.id
                  }
                })
              }}>{ Lang[ 'SEARCH' ][ props.data.languageReducer.lang ] }</Button>
            <Button
              color="danger"
              onClick={ () => {
                props.onChangePrivacyPolicyHOC( 'searchCenter', {} )
                props.getAllPrivacyPolicies({ page: 1, is_paginated: true })
              }}>{ Lang[ 'RESET' ][ props.data.languageReducer.lang ] }</Button>
          </CardFooter>
        </Card>
        <ARKTable
          data={ props.privacyPolicies.data }
          columns={[
            {
              Header: Lang[ 'CENTER' ][ props.data.languageReducer.lang ],
              accessor: 'center_name'
            },
            {
              Header: Lang[ 'ACTION' ][ props.data.languageReducer.lang ],
              accessor: "id",
              Cell: ( row ) => (
                <div className="d-flex flex-row align-items-center justify-content-center w-100">
                  <Button
                    id={ `Privacy-Policy-${ row.original.id }-view` }
                    className="mb-2 mr-2 btn-icon btn-icon-only"
                    color="primary"
                    onClick={ () => props.getSelectedPrivacyPolicy( row.original.center_id, 'view' ) }>
                    <i className="pe-7s-look"> </i>
                  </Button>
                  <UncontrolledTooltip
                    target={ `Privacy-Policy-${ row.original.id }-view` }
                    placement="top">{ Lang[ 'VIEW_PRIVACY_POLICY' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                  {
                    handleSecurityModulesUpdate() && !row.original.is_signed_policy && (
                      <>
                        <Button
                          id={ `Privacy-Policy-${ row.original.id }-edit` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="primary"
                          onClick={ () => props.getSelectedPrivacyPolicy( row.original.center_id, 'edit' ) }>
                          <i className="pe-7s-note"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `Privacy-Policy-${ row.original.id }-edit` }
                          placement="top">{ Lang[ 'EDIT_PRIVACY_POLICY' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                </div>
              )
            }
          ]}
          totalPages={ props.privacyPolicyTotalPages }
          page={ props.privacyPolicies.meta ? props.privacyPolicies.meta.current_page : 1 }
          onChangePage={ pg => props.getAllPrivacyPolicies({ page: pg, is_paginated: true }) }
          showPagination={ false } />
        { renderEditModal() }
        { renderViewModal() }
      </div>
      { props.onLoadPrivacyPolicy && <LoadingModal /> }
    </>
  )
}

export default PrivacyPolicyHOC( PrivacyPolicy )
